"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleBimEvents = void 0;
const rxjs_1 = require("rxjs");
const _PreviewActions = require("../../../modules/files/preview");
const eventTypes = require("../eventTypes");
const utils_1 = require("../utils");
const PreviewActionsFiles = _PreviewActions.actions.default('files');
const PreviewActionsTender = _PreviewActions.actions.default('tender-documents');
const handlePreviewGenerateSuccess = (action) => (0, utils_1.validate)(action.payload, eventTypes.iBimUploadEvent, () => {
    const event = action.payload;
    return (0, rxjs_1.of)(PreviewActionsFiles.generatePreviewSuccess(event.message.previewUUID, event.message.revisionUuid, 'PROCESSED'), PreviewActionsTender.generatePreviewSuccess(event.message.previewUUID, event.message.revisionUuid, 'PROCESSED'));
});
const handlePreviewGenerateFailure = (action) => (0, utils_1.validate)(action.payload, eventTypes.iBimUploadEvent, () => {
    const event = action.payload;
    return (0, rxjs_1.of)(PreviewActionsFiles.generatePreviewFailure(undefined, event.message.revisionUuid), PreviewActionsTender.generatePreviewFailure(undefined, event.message.revisionUuid));
});
const handlers = {
    [eventTypes.GENERATE_PREVIEW_SUCCESS]: handlePreviewGenerateSuccess,
    [eventTypes.GENERATE_PREVIEW_FAILURE]: handlePreviewGenerateFailure
};
const handleBimEvents = (action) => { var _a, _b; return (_b = (_a = handlers[action.payload.event]) === null || _a === void 0 ? void 0 : _a.call(handlers, action)) !== null && _b !== void 0 ? _b : rxjs_1.EMPTY; };
exports.handleBimEvents = handleBimEvents;
//# sourceMappingURL=bim.js.map